var _path, _path2, _path3, _polygon, _path4, _polygon2, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrvtoGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    "data-name": "Layer 1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.75,16A7.7446,7.7446,0,0,1,8.7177,18.6259L4.2849,22.1721A13.244,13.244,0,0,0,29.25,16",
    fill: "#00ac47"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.75,16a7.7387,7.7387,0,0,1-3.2516,6.2987l4.3824,3.5059A13.2042,13.2042,0,0,0,29.25,16",
    fill: "#4285f4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25,16a7.698,7.698,0,0,1,.4677-2.6259L4.2849,9.8279a13.177,13.177,0,0,0,0,12.3442l4.4328-3.5462A7.698,7.698,0,0,1,8.25,16Z",
    fill: "#ffba00"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ab2db",
    points: "8.718 13.374 8.718 13.374 8.718 13.374 8.718 13.374"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16,8.25a7.699,7.699,0,0,1,4.558,1.4958l4.06-3.7893A13.2152,13.2152,0,0,0,4.2849,9.8279l4.4328,3.5462A7.756,7.756,0,0,1,16,8.25Z",
    fill: "#ea4435"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ab2db",
    points: "8.718 18.626 8.718 18.626 8.718 18.626 8.718 18.626"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.25,15v1L27,19.5H16.5V14H28.25A1,1,0,0,1,29.25,15Z",
    fill: "#4285f4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrvtoGoogle);
export default __webpack_public_path__ + "static/media/trvto_google.14e1fe1502a44cdee06685bd11d374e7.svg";
export { ForwardRef as ReactComponent };